import { format, isValid, parseISO } from "date-fns";

export const REG_COL_KEY = "girinestham.adminTournamentRegApprovals.columns";
export const RES_COL_KEY = "girinestham.adminTournamentResultApprovals.columns";
export const REG_PAGE_SIZE = 20;
export const RES_PAGE_SIZE = 20;

export const REG_COLUMN_DEFS = [
  { id: "student_code", label: "Student code", defaultVisible: true, sortable: true },
  { id: "student_name", label: "Student name", defaultVisible: true, sortable: true },
  { id: "student_contact", label: "Contact", defaultVisible: true, sortable: true },
  { id: "student_email", label: "Email", defaultVisible: false, sortable: true },
  { id: "membership_name", label: "Membership", defaultVisible: true, sortable: true },
  { id: "student_membership_id", label: "Membership ID", defaultVisible: false, sortable: true },
  { id: "tournament_name", label: "Tournament", defaultVisible: true, sortable: true },
  { id: "tournament_code", label: "Tournament code", defaultVisible: false, sortable: true },
  { id: "tournament_date", label: "Tournament date", defaultVisible: true, sortable: true },
  { id: "tour_registration_date", label: "Registered on", defaultVisible: true, sortable: true },
  { id: "registration_verified", label: "Registration verified", defaultVisible: true, sortable: true },
  { id: "payment_verified", label: "Payment verified", defaultVisible: true, sortable: true },
  {
    id: "has_verified_result",
    label: "Tournament result verified",
    defaultVisible: true,
    sortable: true,
  },
  { id: "certificate_template_name", label: "Certificate template", defaultVisible: true, sortable: true },
  { id: "certificate_status_name", label: "Certificate allowed", defaultVisible: true, sortable: true },
  { id: "receipt_no", label: "Receipt no.", defaultVisible: true, sortable: true },
  { id: "payment_date", label: "Payment date", defaultVisible: true, sortable: true },
  { id: "amount_paid", label: "Amount paid", defaultVisible: true, sortable: true },
  { id: "payment_mode_name", label: "Payment mode", defaultVisible: false, sortable: true },
];

/** Row checkbox + data columns + row actions — column visibility picker only. */
export const REG_PICKER_COLUMN_DEFS = [
  { id: "__select", label: "Select", defaultVisible: true },
  ...REG_COLUMN_DEFS,
  { id: "actions", label: "Actions", defaultVisible: true },
];

export const RESULT_COLUMN_DEFS = [
  { id: "tournament_name", label: "Tournament", defaultVisible: true, sortable: true },
  { id: "tournament_code", label: "Code", defaultVisible: false, sortable: true },
  { id: "tournament_date", label: "Event date", defaultVisible: true, sortable: true },
  { id: "student_code", label: "Student code", defaultVisible: true, sortable: true },
  { id: "student_name", label: "Student name", defaultVisible: true, sortable: true },
  { id: "student_contact", label: "Contact", defaultVisible: false, sortable: true },
  { id: "result_name", label: "Result type", defaultVisible: true, sortable: true },
  { id: "certificate_template_name", label: "Certificate template", defaultVisible: true, sortable: true },
  { id: "certificate_status", label: "Certificate allowed", defaultVisible: true, sortable: true },
  { id: "result_verified", label: "Result verified", defaultVisible: true, sortable: true },
  { id: "result_created_at", label: "Recorded on", defaultVisible: true, sortable: true },
];

export const RESULT_PICKER_COLUMN_DEFS = [
  { id: "__select", label: "Select", defaultVisible: true },
  ...RESULT_COLUMN_DEFS,
  { id: "actions", label: "Actions", defaultVisible: true },
];

export function loadVis(key, defs) {
  let stored = {};
  try {
    const raw = localStorage.getItem(key);
    if (raw) stored = JSON.parse(raw) || {};
  } catch {
    stored = {};
  }
  const initial = {};
  for (const c of defs) {
    const k = c.id;
    initial[k] =
      Object.prototype.hasOwnProperty.call(stored, k) ? !!stored[k] : !!c.defaultVisible;
  }
  return initial;
}

export function formatDateCell(value) {
  if (value == null || value === "") return "—";
  try {
    const raw = String(value).trim();
    let d = parseISO(raw);
    if (!isValid(d) && /^\d{4}-\d{2}-\d{2}/.test(raw)) d = new Date(raw.replace(" ", "T"));
    if (!isValid(d)) d = new Date(raw);
    return isValid(d) ? format(d, "PP") : "—";
  } catch {
    return "—";
  }
}

export function formatDateTimeCell(value) {
  if (value == null || value === "") return "—";
  try {
    const raw = String(value).trim();
    let d = parseISO(raw);
    if (!isValid(d) && /^\d{4}-\d{2}-\d{2}/.test(raw)) d = new Date(raw.replace(" ", "T"));
    if (!isValid(d)) d = new Date(raw);
    return isValid(d) ? format(d, "PPp") : "—";
  } catch {
    return "—";
  }
}

export function formatMoney(value) {
  if (value == null || value === "") return "—";
  const n = Number(value);
  return Number.isFinite(n) ? `₹${n.toFixed(2)}` : "—";
}

export function isTruthyBool(v) {
  return v === true || v === 1 || v === "1" || v === "true";
}

export function rowDateToStartOfDay(value) {
  if (!value) return null;
  try {
    const raw = String(value).trim();
    let d = parseISO(raw);
    if (!isValid(d)) d = new Date(raw);
    if (!isValid(d)) return null;
    const day = new Date(d);
    day.setHours(0, 0, 0, 0);
    return day;
  } catch {
    return null;
  }
}

export function regCell(columnId, row) {
  switch (columnId) {
    case "tournament_date":
    case "tour_registration_date":
    case "payment_date":
      return formatDateCell(row[columnId]);
    case "amount_paid":
      return formatMoney(row[columnId]);
    case "registration_verified":
    case "payment_verified":
    case "has_verified_result":
      return isTruthyBool(row[columnId]) ? "Yes" : "No";
    default:
      return row[columnId] ?? "—";
  }
}

export function resCell(columnId, row) {
  switch (columnId) {
    case "tournament_date":
      return formatDateCell(row[columnId]);
    case "result_created_at":
      return formatDateTimeCell(row.result_created_at);
    case "result_verified":
    case "certificate_status":
      return isTruthyBool(row[columnId]) ? "Yes" : "No";
    default:
      return row[columnId] ?? "—";
  }
}

function rawRegSort(row, columnId) {
  switch (columnId) {
    case "registration_verified":
    case "payment_verified":
    case "has_verified_result":
      return isTruthyBool(row[columnId]) ? 1 : 0;
    case "amount_paid": {
      const n = Number(row[columnId]);
      return Number.isFinite(n) ? n : 0;
    }
    case "tournament_date":
    case "tour_registration_date":
    case "payment_date": {
      const raw = row[columnId];
      if (raw == null || raw === "") return 0;
      const t = new Date(raw).getTime();
      return Number.isFinite(t) ? t : 0;
    }
    default: {
      const v = row[columnId];
      if (v == null) return "";
      return String(v).toLowerCase();
    }
  }
}

export function compareReg(a, b, columnId) {
  const va = rawRegSort(a, columnId);
  const vb = rawRegSort(b, columnId);
  if (typeof va === "number" && typeof vb === "number") {
    if (va < vb) return -1;
    if (va > vb) return 1;
    return 0;
  }
  return String(va).localeCompare(String(vb), undefined, { numeric: true, sensitivity: "base" });
}

function rawResSort(row, columnId) {
  switch (columnId) {
    case "result_verified":
    case "certificate_status":
      return isTruthyBool(row[columnId]) ? 1 : 0;
    case "tournament_date":
    case "result_created_at": {
      const raw = columnId === "result_created_at" ? row.result_created_at : row.tournament_date;
      if (raw == null || raw === "") return 0;
      const t = new Date(raw).getTime();
      return Number.isFinite(t) ? t : 0;
    }
    default: {
      const v = row[columnId];
      if (v == null) return "";
      return String(v).toLowerCase();
    }
  }
}

export function compareRes(a, b, columnId) {
  const va = rawResSort(a, columnId);
  const vb = rawResSort(b, columnId);
  if (typeof va === "number" && typeof vb === "number") {
    if (va < vb) return -1;
    if (va > vb) return 1;
    return 0;
  }
  return String(va).localeCompare(String(vb), undefined, { numeric: true, sensitivity: "base" });
}

export function exportApprovalsCsv(columns, rows, cellFn, prefix) {
  const headers = columns.map((c) => c.label).join(",");
  const lines = rows.map((row) =>
    columns
      .map((c) => {
        const text = String(cellFn(c.id, row) ?? "");
        return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
      })
      .join(","),
  );
  const csv = [headers, ...lines].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const today = new Date();
  const y = today.getFullYear();
  const m = String(today.getMonth() + 1).padStart(2, "0");
  const d = String(today.getDate()).padStart(2, "0");
  a.download = `${prefix}-${y}-${m}-${d}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
